import { WithActions } from 'projects/mypay4-fe-common/src/public-api';

export class TipoDovuto extends WithActions {
  mygovEnteTipoDovutoId: number;
  codIpaEnte: string;
  codTipo: string;
  deTipo: string;
  esterno: boolean;
}
